import { COOKIE_NAME_CONSENT_STATUS, getCookieValue } from 'dibs-consented-storage';

/** OneTrust categories: Strictly Necessary, Performance, Functional, Targeting, Social Media. */
export type ConsentGroup = 'C0001' | 'C0002' | 'C0003' | 'C0004' | 'C0005';

const parseConsentGroups = (groupsParam: string): Record<string, boolean> =>
    Object.fromEntries(
        groupsParam.split(',').map(entry => {
            const [key, value] = entry.split(':');
            return [key, value === '1'];
        })
    );

/**
 * True only when OneTrust has recorded consent for every group. A visitor who hasn't interacted
 * with OneTrust yet (no consent cookie / no groups) is treated as not consented.
 */
export const hasConsentForGroups = (cookie: string, groups: readonly ConsentGroup[]): boolean => {
    const consentStatus = getCookieValue(cookie, COOKIE_NAME_CONSENT_STATUS);
    const groupsParam = consentStatus ? new URLSearchParams(consentStatus).get('groups') : null;

    if (!groupsParam) {
        return false;
    }

    const consentedGroups = parseConsentGroups(groupsParam);
    return groups.every(id => consentedGroups[id] === true);
};
